import { actions, types } from './requests'
export const GETBADGESCAN_TYPES = {
    ...types('GETBADGESCAN'),
}
export const GETBADGESCAN_ACTIONS = {
    ...actions('GETBADGESCAN'),
}